<template>
    <div class="product-finder__results">
        <global-loading-overlay :showLoading="freeze && freeze !=='no-overlay'">
            {{localization.loading}}
        </global-loading-overlay>
        <div class="result-count col-12"><p>{{ total }}&nbsp;<span v-html="localization.labels.results"></span></p><div class="decoration"></div></div>
        <template v-if="results.length">
            <template v-for="result in results">
                <div :class="['global-material-tile', constants.gridColumns[cols]] ">
                    <a class="tile--link" :href="result.detail_link" @click="openLink(result.detail_link, $event)">
                        <img width="200" height="200" class="tile--image img-fluid" :title="result.title" :src="result.image_src"
                             :alt="result.title" @load="onImageLoaded">
                        <p class="tile--title"><b>{{ result.title }}</b>&nbsp;{{ result.titlesuffix }}</p>
                        <p class="tile--subtitle">{{ result.subtitle }}</p>
                    </a>
                </div>
            </template>
            <template v-if="(total - results.length) > 0">
                <div class="button-wrapper v-center right col-12">
                    <span class="button-label">{{ results.length }}&nbsp;<span v-html="localization.labels.of"></span>&nbsp;{{ total }}&nbsp;<span v-html="localization.labels.results"></span></span>
                    <button class="button button--secondary" @click="loadmore"
                            v-html="localization.labels.loadmore"></button>
                </div>
            </template>
        </template>
        <template v-else>
            <template v-for="i in 12">
                <div :key="'tile-placeholder-' + i" :class="['global-material-tile', constants.gridColumns[cols]] ">
                    <div class="global-material-tile__placeholder">

                    </div>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import {constants} from "@productfinder/shared/constants";
import {helper} from "@productfinder/shared/helper";
import GlobalLoadingOverlay from '../../../../../../global/global-elements/global-loading-overlay/global-loading-overlay';

export default {
        name: "sal-results",
        components: {GlobalLoadingOverlay},
        computed: {
            freeze() {
                return this.$store.state.freeze;
            },
            results() {
                return this.$store.getters.getResults;
            },
            cols() {
                return this.$store.state.config.cols;
            },
            constants() {
                return constants;
            },
            localization() {
                return this.$store.state.localization;
            },
            total() {
                return this.$store.state.total;
            },
            useHash() {
                return this.$store.state.useHash;
            }
        },
		beforeUpdate() {
        	this.imagesLoaded = 0;
		},
        methods: {
            loadmore() {
                this.$store.dispatch('loadMoreResults');
            },
            openLink(targetUrl, event) {
                event.preventDefault();

                if (this.useHash) {
                    // Offset muss hier reduziert werden, da results.length schon das Offset für eine Seite mehr wäre
                    const offset = Math.max(this.$store.state.results.length - constants.resultsPerPage, 0);
                    const scrollOffset = Math.floor(window.pageYOffset); // Damit da kein 2160.23452534532 rauskommt....

                    // for history back
                    // console.log('replacing history with', window.location.pathname+'#'+encodeURI(helper.generateHash(this.$store.getters.selectedFilters))+'#'+offset+','+scrollOffset);
                    history.replaceState({}, '', window.location.pathname + '#' + encodeURI(helper.generateHash(this.$store.getters.selectedFilters)) + '#' + offset + ',' + scrollOffset);



                    // for back to selection button on target page
                    // console.log('navigating to', targetUrl+'#'+encodeURI(helper.generateHash(this.$store.getters.selectedFilters))+'#'+offset+','+scrollOffset);
                    const encoded = window.btoa(window.location.pathname + '#' + helper.generateHash(this.$store.getters.selectedFilters) + '#' + offset + ',' + scrollOffset)

                    window.location.href = targetUrl + '#' + encodeURI(encoded);
                }
                else {
                    window.open(targetUrl);
                }
            },
			onImageLoaded() {
            	// bwoah... Das funktioniert nur für den Fall für den es ursprünglich implementiert wurde
				// sprich das triggern des scrollens, wenn alle Bilder geladen wurden.
				// Bei Filter-Änderungen werden nur die Bilder neu generiert, die sich ändern.
				// Wenn man also bei einer Filter-Änderung von den 12 Ergebnissen nur 5 neue Ergebnisse hat, dann zählt das nur bis 5.
            	this.imagesLoaded++;
				// console.log('An image was loaded', this.imagesLoaded, 'of', this.$store.state.results.length);

            	if (this.$store.state.results.length === this.imagesLoaded) {
					this.$nextTick(function () {
						this.$store.dispatch('allResultImagesLoaded');
					})
				}
			}
        }
    }
</script>
